(() => {
  const configElement = document.getElementById('GmlCountryLanguageConfig');
  const form = document.getElementById('GmlCountryLanguageForm');
  if (!configElement || !form || window.Shopify?.designMode) return;

  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const available = new Map((config.available || []).map(code => [String(code).toLowerCase(), code]));
  const current = String(config.current || '').toLowerCase();
  if (!available.has(current)) return;

  const preferenceKey = 'gml-language-choice-v1';
  const checkedKey = 'gml-country-language-checked-v1';
  const read = (storage, key) => {
    try { return window[storage].getItem(key); } catch { return null; }
  };
  const write = (storage, key, value) => {
    try {
      window[storage].setItem(key, value);
      return window[storage].getItem(key) === value;
    } catch { return false; }
  };
  const remember = language => {
    const code = String(language || '').toLowerCase();
    if (!available.has(code)) return;
    write('localStorage', preferenceKey, code);
    write('sessionStorage', preferenceKey, code);
  };
  const preference = () => read('localStorage', preferenceKey) || read('sessionStorage', preferenceKey);
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement) || event.target === form) return;
    const submitter = event.submitter;
    const input = event.target.querySelector('[name="language_code"]');
    if (!input) return;
    remember(submitter?.name === 'language_code' ? submitter.value : input.value);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[hreflang],a[data-gml-language-choice]');
    if (!link) return;
    remember(link.hreflang || link.dataset.gmlLanguageChoice);
  }, true);

  const pathLanguage = location.pathname.split('/')[1].toLowerCase();
  const params = new URLSearchParams(location.search);
  const regionalLanguage = /^[a-z]{2}-[a-z]{2,4}$/.test(pathLanguage) && available.has(pathLanguage.split('-')[0]);
  const explicitLanguage = available.has(pathLanguage) || regionalLanguage || params.has('locale') || params.has('language') || params.has('language_code');
  if (explicitLanguage || current !== 'en') {
    remember(current);
    return;
  }
  if (preference() || read('sessionStorage', checkedKey)) return;
  if (/^\/(?:account|admin|apps|cart|checkouts?|challenge|password)(?:[/.]|$)/i.test(location.pathname)) return;
  if (document.visibilityState !== 'visible') return;
  if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') return;
  if (!write('sessionStorage', checkedKey, '1')) return;

  let interacted = false;
  const controller = new AbortController();
  const stop = () => {
    interacted = true;
    controller.abort();
  };
  ['pointerdown', 'keydown', 'click', 'wheel', 'submit'].forEach(type => document.addEventListener(type, stop, { capture: true, once: true, passive: true }));
  window.addEventListener('pagehide', stop, { once: true });
  window.addEventListener('popstate', stop, { once: true });

  const countryLanguages = [
    ['en', 'CA US'],
    ['es', 'AR BO CL CO CR CU DO EC ES GQ GT HN MX NI PA PE PR PY SV UY VE'],
    ['ar', 'AE BH DJ DZ EG EH IQ JO KM KW LB LY MA MR OM PS QA SA SD SO SY TN YE'],
    ['fr', 'FR MC'],
    ['it', 'IT SM VA'],
    ['zh-cn', 'CN']
  ];
  const languageFor = country => countryLanguages.find(([, countries]) => countries.split(' ').includes(country))?.[0] || 'en';
  const root = new URL(config.root || '/', location.origin);
  root.pathname = root.pathname.replace(/\/?$/, '/');
  const endpoint = new URL('browsing_context_suggestions.json', root);
  endpoint.searchParams.set('country[enabled]', 'true');
  endpoint.searchParams.set('language[enabled]', 'false');
  const timeout = window.setTimeout(() => controller.abort(), 1800);
  fetch(endpoint.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      if (interacted || controller.signal.aborted || preference() || document.visibilityState !== 'visible') return;
      const country = String(data?.detected_values?.country?.handle || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(country)) return;
      const language = languageFor(country);
      if (language === current || !available.has(language)) return;
      const languageInput = form.querySelector('[name="language_code"]');
      const returnInput = form.querySelector('[name="return_to"]');
      if (!languageInput || !returnInput) return;
      languageInput.value = available.get(language);
      returnInput.value = location.pathname + location.search + location.hash;
      HTMLFormElement.prototype.submit.call(form);
    })
    .catch(() => {})
    .finally(() => window.clearTimeout(timeout));
})();
